<template>
  <div class="broadcast-box animateMove" data-scroll data-scroll-call="animateMove">
    <div class="broadcast-vide" >
      <figure >
        <img data-scroll data-scroll-speed="-3" src="@/assets/images/video.png" alt=""/>
      </figure>
      <!-- <video v-if="broadcaseData.length > 0" class="broadcast-video" id="change-video" v-show="videoShow" ref="chanageVideo" :poster="broadcaseData[nextIndex].thumb" preload="none" x5-video-player-type="h5" x5-video-player-fullscreen="true" x-webkit-airplay="allow" :src="broadcaseData[nextIndex].video" webkit-playsinline playsinline controls>
          <source :src="broadcaseData[nextIndex].video" type="video/mp4">
      </video> -->
      <video class="video-js vjs-default-skin broadcast-video" v-show="videoShow" id="videoPlayer" ref="chanageVideo" :poster="broadcaseData.thumb" controls playsinline>
          <!-- <source :src="broadcaseData[nextIndex].video" type="application/x-mpegURL"> -->
      </video>
      <div class="video-btn" @mousemove="chageMove($event)" v-show="!videoShow" @click="playvideo"><img v-show="broadcaseData.video != ''" :style="{ left: scrollX, top: scrolltop }" src="@/assets/images/videobtns.png" alt=""/></div>
    </div>
    <!-- <div class="session-btns" v-if="broadcaseData.length > 0" @click="changeVideopop">
      <span>场次<br>选择</span>
    </div> -->
    <div class="session-flex" :class="{'show': videoMobile}">
      <div class="session-bg" @click="videomhide"></div>
      <div class="session-mobile">
        <div class="session-tops">
          <h3>场次选择</h3>
          <span class="sessbtns" @click="playvideo">确认</span>
        </div>
        <ul class="session-li" v-if="broadcaseData.length > 0">
          <li v-for="(item1, index2) in broadcaseData" :key="item1.id" :class="{'active': activeIdex == index2}" @click="changeSession(index2)">
            <div class="session-span">
              <i></i>
              <span>{{item1.title}}</span>
            </div>
            <div class="session-images">
              <img :src="item1.thumb" alt=""/>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- <div class="sessions" v-show="broadcaseData.length > 1">
      <div class="sessions-left">
        <p>场次<br>选择</p>
        <ul class="sessions-btn">
          <li v-for="(item,index) in broadcaseData" :key="item.id" :class="{'active': activeIdex == index}" @mouseover="changeSession(index)" @click="playvideo"></li>
        </ul>
      </div>
      <div class="sessions-info">
        <div class="sessions-item" v-for="(item1,index1) in broadcaseData" :key="item1.id" v-show="activeIdex == index1">
          <p>{{item1.title}}</p>
          <img :src="item1.thumb" alt=""/>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import videojs from "video.js";
import "video.js/dist/video-js.css";
export default {
  data () {
    return {
      scrollX: 0,
      scrollY: 0,
      scrolltop: 0,
      activeIdex: 0,
      nextIndex: 0,
      scrollX: '50%',
      scrollY: '',
      scrolltop: "50%",
      videoShow: false,
      videoMobile: false,
      dp: null,
      options: {
        autoplay: true, // 设置自动播放
        muted: false, // 设置了它为true，才可实现自动播放,同时视频也被静音（Chrome66及以上版本，禁止音视频的自动播放）
        preload: "auto", // 预加载
        controls: true, // 显示播放的控件
      },
      player: null
    }
  },
  props: {
    broadcaseData: Object
  },
  methods: {
    changeSession (index) {
      this.activeIdex = index
    },
    chageMove (e) {
      this.scrollX = e.clientX + 'px'
      this.scrolltop = (e.clientY + this.scrollY) + 'px'
    },
    playvideo () {
      if(this.broadcaseData.video != ''){
        this.nextIndex = this.activeIdex
        this.videoShow = true
        this.videoMobile = false
        this.$nextTick(() => {
          console.log(this.broadcaseData)
          setTimeout(() => {
            this.getVideo(this.broadcaseData.video)
          }, 600)
        })
      }
    },
    getVideo(nowPlayVideoUrl) {
      if(nowPlayVideoUrl != ''){
        this.player = videojs('videoPlayer', this.options)
        this.player.src([
          {
            src: nowPlayVideoUrl,
            type: 'video/mp4'
          }
        ])
      }
      
    },
    chageMove (e) {
      this.scrollX = e.clientX + 'px'
      this.scrolltop = (e.clientY + this.scrollY) + 'px'
    },
    changeVideopop () {
      this.videoMobile = true
    },
    videomhide () {
      this.videoMobile = false
    },
    scrollBac () {
      setTimeout(() => {
        this.scroll.on('scroll', (args) => {
          this.scrollY = Math.round(args.scroll.y)
        })
      })
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose() 
    }
  },
  mounted () {
    this.scrollBac()
  }
}
</script>

<style lang="less" scoped>
@import url("@/assets/css/home/index.less");
</style>